export enum SportType {
  minifootball = 'minifootball',
  football = 'football',
  floorball = 'floorball',
  hockey = 'hockey',
  basketball = 'basketball',
  volleyball = 'volleyball',
  water_polo = 'water_polo',
  bowling = 'bowling',
}
